import React from 'react'
import './Portfolio.css'
import IMG1 from '../../assets/portfolio1.png'
import IMG2 from '../../assets/portfolio2.png'
import IMG3 from '../../assets/portfolio3.png'
import IMG4 from '../../assets/portfolio4.png'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.png'
import IMG7 from '../../assets/portfolio7.png'
import IMG8 from '../../assets/portfolio8.png'

const data = [
    {
        id: 1,
        image: IMG1,
        title: 'IMDb Clone Website',
        github: 'https://github.com/DivyaGaurav21/IMDb_Clone-website',
        demo: 'https://divyagaurav21.github.io/IMDb_Clone-website/'
    },
    {
        id: 2,
        image: IMG4,
        title: 'E-Commerce Meal-Hub',
        github: 'https://github.com/DivyaGaurav21/Ecoomerce-React-App',
        demo: 'https://ecommerce-meal.netlify.app/'
    },
    {
        id: 3,
        image: IMG3,
        title: 'VTuBe',
        github: 'https://github.com/DivyaGaurav21/vidTube',
        demo: 'https://divyagaurav-vtube.netlify.app/'
    },
    {
        id: 4,
        image: IMG2,
        title: 'Habit Tracker(Node)',
        github: 'https://github.com/DivyaGaurav21/habbit_tracker_nodejs',
        demo: 'http://habit-tracker-dg.onrender.com/'
    },
    {
        id: 5,
        image: IMG5,
        title: 'HomeHaven',
        github: 'https://github.com/DivyaGaurav21/Traveller-Stay-Point',
        demo: 'https://divyagaurav-homehaven.netlify.app/'
    },
    {
        id: 6,
        image: IMG6,
        title: 'Landing New Year',
        github: 'https://github.com/DivyaGaurav21/Employee-Review-System',
        demo: 'https://employee-review-system-dg.onrender.com/'
    },
    {
        id: 7,
        image: IMG7,
        title: 'Todo-List',
        github: 'https://github.com/DivyaGaurav21/TodoList_Vanilla',
        demo: 'https://divyagaurav21.github.io/TodoList_Vanilla/'
    },{
        id: 7,
        image: IMG8,
        title: 'Music-Player',
        github: 'https://github.com/DivyaGaurav21/music-player',
        demo: 'https://divyagaurav21.github.io/music-player/'
    }
    
]

const Portfolio = () => {
  return (
      <section id="portfolio">
          <h5>My Reacent Work</h5>
          <h2>Portfolio</h2>

          <div className="container portfolio__container">
              
          {
                  data.map(item => (
                          <article key={item.id} className="portfolio__item">
                              <div className="portfolio__item-image">
                                  <img src={item.image} alt="imageport" />
                              </div>
                          <h3>{ item.title}</h3>
                              <div className="portfolio__item-cta">
                                  <a href={item.github} target='_blank' rel='noreferrer' className='btn'>Github</a>
                                  <a href={item.demo} target='_blank' rel='noreferrer' className='btn btn-primary'>Live Demo</a>
                              </div>
                          </article>
                )
            )      
         }
              
          </div>
    </section>
  )
}

export default Portfolio